import React, { useEffect, useState, useImperativeHandle, forwardRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { TextField, Checkbox, FormControlLabel } from "@mui/material";
import "./DataTagFileSearch.scss";
import { FETCH_DATA_TAG_USERS_LIST } from "../DataTagConstants";

const DataTagUserSearch = forwardRef((props, ref) => {
  const dispatch = useDispatch();
  const filesList = useSelector(
    (state) => state.dataTagReducer.searchedDataTagUsers
  );

  const [search, setSearch] = useState("");
  const [selected, setSelected] = useState([]);


  useEffect(() => {
    if (props.selectedValues && Array.isArray(props.selectedValues)) {
      setSelected(props.selectedValues);
    }
  }, [props.selectedValues]);

  useEffect(() => {
    dispatch({
      type: FETCH_DATA_TAG_USERS_LIST,
      payload: { userName: search },
    });
  }, [search, dispatch]);

  const toggleSelected = (name) => {
    setSelected((prev) => {
      const updated = prev.includes(name)
        ? prev.filter((x) => x !== name)
        : [...prev, name];

      props.onSelectionChange?.(updated);

      return updated;
    });
  };

  const clearSelection = () => setSelected([]);
  const applySelection = () => selected;

  useImperativeHandle(ref, () => ({
    clear: clearSelection,
    apply: applySelection,
  }));

  return (
    <div className="data-tag-file-search-container">
      <TextField
        size="small"
        placeholder="Search users..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        fullWidth
        className="search-input"
      />

      <div className="data-tag-file-list">
        {filesList?.length > 0 ? (
          filesList.map((name) => (
            <FormControlLabel
              key={name}
              className="file-item"
              control={
                <Checkbox
                  size="small"
                  checked={selected.includes(name)}
                  onChange={() => toggleSelected(name)}
                />
              }
              label={name}
            />
          ))
        ) : (
          <p className="no-data">No files found</p>
        )}
      </div>
    </div>
  );
});

export default DataTagUserSearch;
